import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Lightbox from 'react-image-lightbox'

import useStyles from './image.style'

const Image = (props) => {
  const {
    src,
    alt,
    className,
    onClick,
    modal,
    style
  } = props

  const classes = useStyles(props)
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    if (modal) {
      setIsOpen(!isOpen)
    } else if (onClick) {
      return onClick()
    }

    return false
  }

  return (
    <>
      <img
        alt={alt}
        className={`${className ? `${className} ` : ''}${classes.image}`}
        onClick={handleClick}
        src={src}
        style={style}
      />
      {isOpen && <Lightbox
        mainSrc={src}
        onCloseRequest={e => setIsOpen(!isOpen)}
      />}
    </>
  )
}

Image.defaultProps = {
  alt: '',
  className: '',
  modal: false,
  onClick: () => {},
  src: ''
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  modal: PropTypes.bool,
  onClick: PropTypes.func,
  src: PropTypes.string
}

export default Image
